/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FeedbackGroupByRole } from "../../components/feedbackList/FeedbackGroupByRole";
import { PendingInvitations } from "../../components/feedbackList/PendingInvitations";
import Loading from "../../components/general/Loading";
import emojiCrying from "../../images/emoji-crying.png";
import AuthenticatedLayout from "../../layout/AuthenticatedLayout";
import * as FeedbackService from "../../services/FeedbackService";
import { filterFeedbacksNotRejected } from "../../functions/FilterUsers";
import "./FeedbackList.scss";
import { t } from "i18next";

const FeedbackList = (): React.JSX.Element => {
  const [loading, setLoading] = useState<boolean>(true)
  const [feedbacks, setFeedbacks] = useState<IFeedback[]>()
  const [pendingInvitations, setPendingInvitations] = useState<IFeedback[]>([])

  useEffect(() => {
    loadFeedbacks()
    loadPendingInvitations()
  }, [])

  useEffect(() => {
    if (feedbacks && feedbacks.length > 0) {
      saveEmailsToLocalStorage();
    }
  }, [feedbacks]);

  const saveEmailsToLocalStorage = () => {
    const emails: string[] = []

    feedbacks?.forEach((feedback: IFeedback) => {
      feedback.users.forEach((user: IUser) => emails.push(user.email))
    })

    localStorage.setItem("eventEmails", JSON.stringify([...new Set(emails)]))
  };

  const loadFeedbacks = async (): Promise<void> => {
    await FeedbackService.list((data: any) => {
      setLoading(false)
      const sortedData = data.sort((a: any, b: any) => new Date(`${b.schedule_date} ${b.schedule_time}`).getTime() - new Date(`${a.schedule_date} ${a.schedule_time}`).getTime())
      setFeedbacks(sortedData)
    })
  }

  const loadPendingInvitations = async (): Promise<void> => {
    try {
      const data = await FeedbackService.listPending()
      setPendingInvitations(data as IFeedback[])
    } catch (error) {
      console.error("Erro ao carregar convites pendentes:", error)
    }
  }

  const renderNewFeedbackButton = (): React.JSX.Element => {
    return <Link to="/feedbacks/new" className="btn btn-primary">{t("feedbackList.actions.requestFeedback")}</Link>
  }

  const renderFeedbacks = (): React.JSX.Element => {
    console.log()

    const sessionData = JSON.parse(localStorage.getItem("sessionData") ?? "{}");
    const userID = sessionData.id ?? null;

    // Filtrar feedbacks onde o usuário atual não foi rejeitado
    const filteredFeedbacks = filterFeedbacksNotRejected(feedbacks || [], userID);

    if (!feedbacks || filteredFeedbacks.length === 0) return (
      <div id="feedback-list" className="d-flex flex-column align-items-center justify-content-center">
        <div className="empty-state">
          <img src={emojiCrying} alt="Emoji Crying" />
          <p className="m-0 pt-5 no-feedbacks-message">{t("noFeedbacks.title")}</p>
          <p className="m-0 py-4 schedule-one-message">{t("noFeedbacks.message")}</p>
          {renderNewFeedbackButton()}
        </div>
      </div>
    )

    return (
      <div id="feedback-list" className="">
        <div className="row mb-3">
          <div className="col">
            <h2>{t("feedbackList.titles.main")}</h2>
          </div>
          <div className="col text-end">
            {renderNewFeedbackButton()}
          </div>
        </div>
        <PendingInvitations feedbacks={pendingInvitations} userId={userID} />
        <FeedbackGroupByRole
          role="requester"
          feedbacks={filteredFeedbacks}
          userId={userID}
        />
        <FeedbackGroupByRole
          role="facilitator"
          feedbacks={filteredFeedbacks}
          userId={userID}
        />
        <FeedbackGroupByRole
          role="participant"
          feedbacks={filteredFeedbacks}
          userId={userID}
        />
        </div>
    )
  }

  if (loading) return (
    <AuthenticatedLayout>
      <div id="feedback-list" className="d-flex flex-column align-items-center justify-content-center">
        <Loading />
      </div>
    </AuthenticatedLayout>
  )

  return (
    <AuthenticatedLayout>
      {renderFeedbacks()}
    </AuthenticatedLayout>
  )
}

export default FeedbackList
